// First-load settings dialog. Stores API URL + key + tenant_id in
// localStorage so the bundle itself contains no secrets - disposable UI
// can ship to a public S3+CF without leaking the key.

import { useState } from "react";
import { DEFAULT_BASE_URL } from "../api";
import type { ProfileInput } from "../profiles";

export function ConfigPanel({
  initial,
  onSave,
  onCancel,
}: {
  initial: ProfileInput | null;
  onSave: (profile: ProfileInput) => void;
  onCancel?: () => void;
}) {
  const [name, setName] = useState(initial?.name ?? "");
  const [baseUrl, setBaseUrl] = useState(initial?.baseUrl ?? DEFAULT_BASE_URL);
  const [apiKey, setApiKey] = useState(initial?.apiKey ?? "");
  const [tenantId, setTenantId] = useState(initial?.tenantId ?? "apeak");

  const valid =
    name.trim().length > 0 &&
    baseUrl.trim().startsWith("https://") &&
    apiKey.trim().length > 0 &&
    tenantId.trim().length > 0;

  return (
    <div className="config-screen">
      <div className="config-card">
        <h1>Tenant Admin API · Test UI</h1>
        <p className="config-subtitle">
          Disposable harness for the Logs endpoint. Settings stay in this
          browser's localStorage; the key never leaves your machine.
        </p>

        <label>
          Name
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="APeak - Frankfurt"
            spellCheck={false}
          />
        </label>

        <label>
          API base URL
          <input
            value={baseUrl}
            onChange={(e) => setBaseUrl(e.target.value)}
            placeholder={DEFAULT_BASE_URL}
            spellCheck={false}
          />
        </label>

        <label>
          X-Api-Key
          <input
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
            placeholder="paste from Secrets Manager"
            type="password"
            spellCheck={false}
          />
        </label>

        <label>
          Tenant ID
          <input
            value={tenantId}
            onChange={(e) => setTenantId(e.target.value)}
            placeholder="apeak"
            spellCheck={false}
          />
        </label>

        <button
          className="primary"
          disabled={!valid}
          onClick={() => onSave({ name: name.trim(), baseUrl: baseUrl.trim(), apiKey: apiKey.trim(), tenantId: tenantId.trim() })}
        >
          {initial ? "Save" : "Connect"}
        </button>
        {onCancel && (
          <button className="config-cancel" onClick={onCancel}>
            Cancel
          </button>
        )}
      </div>
    </div>
  );
}
